import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLtUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M36.292 30.907 24 18.615 11.707 30.907l-2.121-2.121L24 14.373l14.413 14.413z" }) }) })
});
export default SvgArrowLtUp;
